import React, {useContext, useEffect, useState} from 'react';
import {CalenderIcon} from "../../../Assets/svg";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {BalanceSheetContext} from "./BalanceSheetContext";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import numericFunction from "../../../utils/NumericFunction";
import numeric from "../../../utils/NumericFunction";
import {toast} from "react-toastify";

function FilterSection(props) {

  // کلید های فیلتر
  const keys = {
    all: "all", yearMonth: "yearMonth", dateBetween: "date",

  }

  const value = useContext(BalanceSheetContext);
  const setData = value.setData
  const data = value.data

  const test = {
    dateFilter: {
      "type": "date", "startDate": "", "endDate": "", year: "", month: "",
    },

    documentNumberFilter: {firstId: "", lastId: ""}, reportType: "1", // kol1 grouh2 moein3
  }


  const dateFilter = data.dateFilter;
  console.log(dateFilter)


  const [loader, setLoader] = useState(false)


  const [isOpenFilter, setIsOpenFilter] = useState(true)

  const [optionData, setOptionData] = useState({
    yearMonthList: [], monthList: [], documentIdList: [],
  })
  const getFilterData = async () => {
    try {
      const resYearMonthList = await _axios.get(prefixUrl() + '/accountingTreeChart/?request=submittedYearAndMonth')

      const documentIdList = (await _axios.get(prefixUrl() + '/accountingTreeChart/?request=submittedDocumentId'))


      setOptionData({
        yearMonthList: resYearMonthList.data.data, documentIdList: documentIdList.data.data
      }) // yearMonthList
      setLoader(false)
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    void getFilterData()
  }, []);


  const requestNewMainData = async () => {
    // ارسال درخواست
    try {
      const res = await _axios.get(prefixUrl() + '/accountingBalanceSheet/?request=balanceSheetData_2' + '&dateFilter=' + JSON.stringify(dateFilter) + '&documentNumberFilter=' + JSON.stringify(data.documentNumberFilter) + '&reportType=' + data.reportType)

      if (res?.data?.status) {
        setData({...data, mainData: res.data.data})
      } else {
        toast.info(res?.data?.message)
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    void requestNewMainData();
  }, [dateFilter.startDate,
    dateFilter.endDate,
    dateFilter.type,
    dateFilter.year,
    dateFilter.month,
    data.reportType,
    data.documentNumberFilter?.firstId,
    data.documentNumberFilter?.lastId,]);


  const yearChangeHandler = (e) => {

    const value = e.target.value;
    const myOptionData = {...optionData}
    const monthList = myOptionData.yearMonthList.find(v => +v.year === +value)?.month


    setData({dateFilter: {...data.dateFilter, year: value, month: ""}})
    setOptionData({...optionData, monthList})
  }

  const monthChangeHandler = (e) => {
    const value = e.target.value;
    setData({...data,dateFilter: {...data.dateFilter, month: value}})

  }
  const typeHandler = (reportType) => {
    setData({...data , reportType})
  }
  return (<div><div className={"filter__section"}>
    <div className={`my-2  `}
         style={{
           transition: "all 0.3s", height: isOpenFilter ? 95 : 40, borderRadius: 10, // padding: isOpenFilter ? 20 : 0,
           // overflowY: "scroll",
         }}
    >


      <div className={'mb-3'}
           onClick={() => setIsOpenFilter(!isOpenFilter)}
      >
        {!isOpenFilter && <span className={'ps-2'}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
  <path
    d="M9.99959 14.0001C9.41626 14.0001 8.83293 13.7751 8.39126 13.3334L2.95795 7.90009C2.71629 7.65843 2.71629 7.25843 2.95795 7.01676C3.19962 6.77509 3.59962 6.77509 3.84129 7.01676L9.2746 12.4501C9.6746 12.8501 10.3246 12.8501 10.7246 12.4501L16.1579 7.01676C16.3996 6.77509 16.7996 6.77509 17.0413 7.01676C17.2829 7.25843 17.2829 7.65843 17.0413 7.90009L11.6079 13.3334C11.1663 13.7751 10.5829 14.0001 9.99959 14.0001Z"
    fill="#5D70B5"
  />
</svg>

          </span>}
        {isOpenFilter && <span className={'ps-2'}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
  <g id="arrow-down-1 10">
    <path
      id="Vector"
      d="M9.99959 5.99994C9.41626 5.99994 8.83293 6.22494 8.39126 6.66661L2.95795 12.0999C2.71629 12.3416 2.71629 12.7416 2.95795 12.9832C3.19962 13.2249 3.59962 13.2249 3.84129 12.9832L9.2746 7.54994C9.6746 7.14994 10.3246 7.14994 10.7246 7.54994L16.1579 12.9832C16.3996 13.2249 16.7996 13.2249 17.0413 12.9832C17.2829 12.7416 17.2829 12.3416 17.0413 12.0999L11.6079 6.66661C11.1663 6.22494 10.5829 5.99994 9.99959 5.99994Z"
      fill="#5D70B5"
    />
  </g>
</svg>
          </span>}

        فیلترها
      </div>
      {isOpenFilter && <>
        <div className={'d-flex'} style={{gap: 20}}>
          <div className={'review__input '}>
            <label htmlFor="yearFiltersReview">فیلتر</label>
            <select
              className={'width__142'}
              id="yearFiltersReview"

              value={dateFilter.type}
              onChange={e => {
                const value = e.target.value
                setData({dateFilter: {...data.dateFilter, type: value}})
              }}
            >
              <option value={keys.all}>همه</option>
              <option value={keys.yearMonth}>بر اساس سال و ماه</option>
              <option value={keys.dateBetween}>بر اساس بازه زمانی</option>
            </select>
          </div>


          {(dateFilter.type === keys.all) && <></>}
          {(dateFilter.type === keys.yearMonth) && <>

            <div className={'review__input'}>
              <label htmlFor="yearFiltersReview">سال</label>
              <select
                className={'width__142'}
                id={'yearFiltersReview'}
                onChange={yearChangeHandler}
                value={dateFilter.year}
                name="yearFiltersReview">
                <option value="" hidden={true}>انتخاب کنید</option>
                {optionData?.yearMonthList?.map((v, i) => {
                  console.log(v)
                  return <option key={i}
                                 value={v.year}>
                    {numericFunction.e2p(v.year)}</option>
                })}
              </select>
            </div>
            <div className={'review__input'}>
              <label htmlFor="monthFiltersReview">ماه</label>
              <select id="monthFiltersReview"
                      className={'width__142'}
                      onChange={monthChangeHandler}
                      value={dateFilter.month}
              >
                <option value="" hidden={true}>انتخاب کنید</option>
                {optionData?.monthList?.map(v => <option key={v + ""} value={v + ""}>{v}</option>)}
              </select>
            </div>
          </>}
          {(dateFilter.type === keys.dateBetween) && <>
            <div className={'d-flex'}>

              <div className={"review__input"}>
                <label>تاریخ شروع</label>
                <div
                  className="datePicker__review ltr d-flex"
                >
                  <CalenderIcon/>
                  <DatePicker
                    id={"dateHereForm"}
                    calendar={persian}
                    className="classNameOfDatePicker "
                    placeholder="تاریخ"
                    name={"bame"}
                    locale={persian_fa}
                    // ref={dateCal}
                    calendarPosition="bottom-right"
                    hideOnScroll
                    value={dateFilter.startDate}
                    onChange={(DateObject) => {
                      if (DateObject) {
                        const temp = numeric.p2e(DateObject.toLocaleString());
                        setData({dateFilter: {...data.dateFilter, startDate: temp}})
                      } else {
                        setData({dateFilter: {...data.dateFilter, startDate: ""}})
                      }
                    }}
                  />
                </div>
              </div>

              <div className={"review__input"}>
                <label>تاریخ پایان</label>
                <div
                  className="datePicker__review ltr d-flex"
                >
                  <CalenderIcon/>
                  <DatePicker
                    id={"dateHereForm"}
                    calendar={persian}
                    // className="classNameOfDatePicker "
                    placeholder="تاریخ"
                    name={"bame"}
                    locale={persian_fa}
                    // ref={dateCal}
                    calendarPosition="bottom-right"
                    hideOnScroll
                    value={dateFilter.endDate}
                    onChange={(DateObject) => {
                      if (DateObject) {
                        const temp = numeric.p2e(DateObject.toLocaleString());
                        setData({dateFilter: {...data.dateFilter, endDate: temp}})
                      } else {
                        setData({dateFilter: {...data.dateFilter, endDate: ""}})
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </>}
          {<div>
            <div className={'d-flex'}>
              <div className={'  review__input'}>
                <label>از شماره سند</label>
                <select
                  className={'width__142'}

                  onChange={e => {

                    const value = e.target.value
                    const newData = {
                      ...data, documentNumberFilter: {...data.documentNumberFilter, firstId: value}
                    }
                    setData(newData)
                  }}

                  value={data.documentNumberFilter.firstId}
                >
                  <option value="" hidden={false}>از ابتدا</option>
                  {optionData.documentIdList.map(val => <option key={val + ""} value={val + ""}>{val}</option>)}
                </select>
              </div>
              <div className={' review__input'}>
                <label> تا شماره سند</label>
                <select
                  className={'width__142'}

                  onChange={e => {

                    const value = e.target.value
                    const newData = {
                      ...data, documentNumberFilter: {...data.documentNumberFilter, lastId: value}
                    }
                    setData(newData)
                  }}
                  value={data.documentNumberFilter.lastId}
                >
                  <option value="" hidden={false}>تا انتها</option>
                  {optionData.documentIdList.map(val => <option key={val + ""} value={val + ""}>{val}</option>)}
                </select>
              </div>
            </div>

          </div>}
        </div>
      </>}

    </div>
  </div>

    <div className={"my-2"}>
      <div className={"d-flex flex"}>
        <button className={`mx-2 py-2 px-3 btn__note__book ${data.reportType==="0" ? 'bg__color__D9DCEA' : 'bg__color__F1F1F1'}`} onClick={() => typeHandler("0")}> گروه</button>
        <button className={`mx-2 py-2 px-3 btn__note__book ${data.reportType==="1" ? 'bg__color__D9DCEA' : 'bg__color__F1F1F1'}`}   onClick={() => typeHandler("1")}> کل</button>
        <button className={`mx-2 py-2 px-3 btn__note__book ${data.reportType==="2" ? 'bg__color__D9DCEA' : 'bg__color__F1F1F1'}`}  onClick={() => typeHandler("2")}> معین</button>
      </div>
    </div>
  </div>);



}

export default FilterSection;